import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App = () => {
  useEffect(() => {
    // Add viewport meta tag for proper mobile scaling
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    }

    const style = document.createElement('style');
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
      
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
      }
      
      html {
        scroll-behavior: smooth;
        font-size: 16px;
      }
      
      body {
        font-family: 'Poppins', sans-serif;
        overflow-x: hidden;
        background: #0a0f1c;
        color: #ffffff;
      }
      
      :root {
        --primary: #C8A97E;
        --primary-dark: #B48C5C;
        --primary-light: #E5D5B5;
        --secondary: #1E2A47;
        --secondary-light: #2A3B62;
        --accent: #F9F3E7;
        --dark: #0A0F1C;
        --dark-light: #151E2F;
        --gold: #D4AF37;
        --gold-light: #F1E5C9;
        --text-light: #E8E8E8;
        --text-dim: #A0A8B8;
        --white: #FFFFFF;
        --whatsapp: #25D366;
        --whatsapp-dark: #128C7E;
        --shadow-sm: 0 10px 30px rgba(0, 0, 0, 0.1);
        --shadow-md: 0 15px 40px rgba(0, 0, 0, 0.2);
        --shadow-lg: 0 20px 60px rgba(0, 0, 0, 0.3);
        --shadow-gold: 0 10px 30px rgba(200, 169, 126, 0.3);
        --gradient-gold: linear-gradient(135deg, #C8A97E, #D4AF37);
        --gradient-dark: linear-gradient(135deg, #0A0F1C, #151E2F);
        --gradient-whatsapp: linear-gradient(135deg, #25D366, #128C7E);
      }
      
      section {
        scroll-margin-top: 80px;
        position: relative;
      }
      
      h1, h2, h3, h4, h5 {
        font-family: 'Playfair Display', serif;
        font-weight: 700;
      }
      
      .container {
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 20px;
        position: relative;
        z-index: 2;
      }
      
      /* Mobile Responsive Breakpoints */
      @media (max-width: 768px) {
        html {
          font-size: 14px;
        }
        
        .container {
          padding: 0 15px;
        }
        
        section {
          scroll-margin-top: 70px;
        }
      }
      
      @media (max-width: 480px) {
        html {
          font-size: 12px;
        }
        
        .container {
          padding: 0 12px;
        }
      }
      
      /* Touch-friendly styles */
      button, a {
        min-height: 44px;
        min-width: 44px;
      }
      
      /* Smooth scrolling for mobile */
      @media (prefers-reduced-motion: reduce) {
        html {
          scroll-behavior: auto;
        }
      }
      
      /* Hide scrollbar for mobile but keep functionality */
      @media (max-width: 768px) {
        ::-webkit-scrollbar {
          width: 4px;
        }
        
        ::-webkit-scrollbar-track {
          background: var(--dark);
        }
        
        ::-webkit-scrollbar-thumb {
          background: var(--primary);
          border-radius: 2px;
        }
      }
      
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }
      
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
      
      @keyframes shimmer {
        0% { background-position: -1000px 0; }
        100% { background-position: 1000px 0; }
      }
      
      @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <div style={{ 
      overflowX: 'hidden',
      background: 'var(--dark)',
      position: 'relative',
      minHeight: '100vh',
      color: '#ffffff'
    }}>
      {/* Background Pattern - Optimized for mobile */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 20% 50%, rgba(200, 169, 126, 0.08) 0%, transparent 60%), radial-gradient(circle at 80% 80%, rgba(212, 175, 55, 0.08) 0%, transparent 60%)',
        pointerEvents: 'none',
        zIndex: 0
      }}></div>
      
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;